.BookingStatus {
  border-radius: 10px;
  padding: 0 0.5rem;
  margin-right: 0.5rem;
}
